
// Performance optimization utilities

export const preloadCriticalResources = () => {
  // Preload critical images
  const criticalImages = [
    '/lovable-uploads/8b8b74eb-433c-4a62-8bca-d62e0179e241.png',
    '/og-image.jpg'
  ];

  criticalImages.forEach(src => {
    const link = document.createElement('link');
    link.rel = 'preload';
    link.href = src;
    link.as = 'image';
    document.head.appendChild(link);
  });
};

export const loadNonCriticalCSS = (href: string) => {
  const link = document.createElement('link');
  link.rel = 'preload';
  link.href = href;
  link.as = 'style';
  link.onload = function() {
    // @ts-ignore
    this.onload = null;
    // @ts-ignore
    this.rel = 'stylesheet';
  };
  document.head.appendChild(link);

  // Fallback for browsers that don't support preload
  const noscript = document.createElement('noscript');
  const fallbackLink = document.createElement('link');
  fallbackLink.rel = 'stylesheet';
  fallbackLink.href = href;
  noscript.appendChild(fallbackLink);
  document.head.appendChild(noscript);
};

export const deferNonCriticalScripts = () => {
  // Add defer attribute to non-critical scripts
  const scripts = document.querySelectorAll('script[src]');
  scripts.forEach(script => {
    if (!script.hasAttribute('defer') && !script.hasAttribute('async')) {
      script.setAttribute('defer', '');
    }
  });
};

export const optimizeImageLoading = () => {
  // Add loading="lazy" to images below the fold
  const images = document.querySelectorAll('img');
  images.forEach((img, index) => {
    if (index > 2) { // Skip first 3 images (likely above fold)
      img.setAttribute('loading', 'lazy');
    }
  });
};

// Initialize performance optimizations
export const initPerformanceOptimizations = () => {
  if (typeof window !== 'undefined') {
    // Run on DOM content loaded
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => {
        preloadCriticalResources();
        deferNonCriticalScripts();
        optimizeImageLoading();
      });
    } else {
      preloadCriticalResources();
      deferNonCriticalScripts();
      optimizeImageLoading();
    }
  }
};
